import { compositionFunction as CallToActionComposition } from 'src/components/Common/@electron/CallToAction/composition';
import Composition from 'src/lib/HOC/Composition';
import data from './data.js';
import MultiLinkCards from './index';

const { compositionFunction, component } = Composition(MultiLinkCards)(
  ({ fields }: typeof data) => {
    const CTA = CallToActionComposition({ fields });
    const items = fields?.Cards.map(card => {
      return {
        title: card.fields?.title?.value,
        description: card.fields?.description?.value,
        icon: card.fields?.icon?.value?.src,
        hideItem: card.fields?.hideCard?.value,
        links: card.fields.linkCards.map(link => {
          return {
            hideLink: link.fields?.HideLink?.value,
            link: link.fields?.Link?.value,
            description: link.fields?.Description?.value,
          };
        }),
        footerLink: card.fields?.footerLink?.value,
      };
    });

    return {
      items,
      CTA,
      title: fields?.Title?.value,
      emphasis: fields?.isSubtleStyle?.value ? 'subtle' : 'base',
    };
  }
);

export { compositionFunction, component as default };
